<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields" :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "Announce",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                  name: 'countryId',
                  placeholder: '国家',
                  type: 'select',
                  selectUrl: '/country/getAll',
                  selectData: [],
                }, {
                    name: 'type',
                    placeholder: '请选择类型',
                    type: 'select',
                    selectValue:[{
                        key: 1,
                        value: '普通公告',
                        type: 'warning'
                    },{
                        key: 2,
                        value: '重要公告',
                        type: 'danger'
                    }]
                }, {
                    name: 'isPop',
                    placeholder: '请选择弹窗类型',
                    type: 'select',
                    selectValue:[{
                        key: 1,
                        value: '弹窗公告',
                        type: 'primary'
                    },{
                        key: 0,
                        value: '非弹窗公告',
                        type: 'warning'
                    }]
                }],
                permission:{
                    add: 'announce:add',
                    update: 'announce:update',
                    delete: 'announce:delete',
                    deleteBatch: 'announce:deleteBatch'
                },
                url: {
                    get: '/announce/listByCondition',
                    add: '/announce/add',
                    update: '/announce/update',
                    delete: '/announce/delete/',
                    delete_batch: '/announce/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                    field: 'title',
                    label: '标题',
                    show: true,
                    width: '',
                }/*, {
                    field: 'content',
                    label: '内容',
                    show: true,
                    width: '',
                }*/, {
                    field: 'type',
                    label: '类型',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '普通公告',
                            type: 'warning'
                        },{
                            key: 2,
                            value: '重要公告',
                            type: 'danger'
                        }]
                    },
                }, {
                    field: 'isPop',
                    label: '弹窗',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '弹窗公告',
                            type: 'primary'
                        },{
                            key: 0,
                            value: '非弹窗公告',
                            type: 'warning'
                        }]
                    },
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                },{
                  field: 'countryId',
                  label: '国家',
                  selectUrl: '/country/getAll',
                  selectData: [],
                  show: {
                    type: 'select'
                  },
                  width: '',
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加公告',
                    updateTitle: '修改公告',
                    model: [{
                        field: 'title',
                        label: '标题',
                        type: 'input',
                        placeholder: '标题',
                        rules:[{message: '请输入标题', trigger: 'blur', required: false}],
                        add: true,
                        update: true,
                    }, {
                        field: 'content',
                        label: '内容',
                        type: 'editor',
                        placeholder: '内容',
                        rules:[{message: '请输入内容', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    },{
                        field: 'type',
                        label: '类型',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '普通公告'
                        }, {
                            id: 2,
                            name: '重要公告'
                        }],
                        placeholder: '请选择类型',
                        rules:[{
                            message: '请选择类型', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'isPop',
                        label: '弹窗',
                        type: 'select',
                        selectData: [{
                            id: 1,
                            name: '弹窗公告'
                        }, {
                            id: 0,
                            name: '非弹窗公告'
                        }],
                        placeholder: '请选择弹窗类型',
                        rules:[{
                            message: '请选择弹窗类型', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                      field: 'countryId',
                      label: '国家ID',
                      type: 'select',
                      selectUrl: '/country/getAll',
                      selectData: [],
                      placeholder: '请选择',
                      rules: [{
                        message: '请选择国家ID', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true,
                    },{
                        field: 'createTime',
                        label: '时间',
                        type: 'dateTime',
                        placeholder: '请选择时间',
                        rules: [{
                            message: '请选择时间', trigger: 'blur', required: true
                        }],
                        //add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
